"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledSvg = _styledComponents2.default.svg.withConfig({
  displayName: "Checkbox__StyledSvg",
  componentId: "sc-12iga07-0"
})(["cursor:", ";"], props => props.disabled ? "not-allowed" : "pointer");

const StyledDiv = _styledComponents2.default.div.withConfig({
  displayName: "Checkbox__StyledDiv",
  componentId: "sc-12iga07-1"
})([""]);

const StyledInput = _styledComponents2.default.input.withConfig({
  displayName: "Checkbox__StyledInput",
  componentId: "sc-12iga07-2"
})(["display:none;"]);

const checkedCheckbox = disabled => _react2.default.createElement(
  StyledSvg,
  {
    disabled: disabled,
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink"
  },
  _react2.default.createElement(
    "g",
    {
      id: "Symbols",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    },
    _react2.default.createElement(
      "g",
      { id: "Checks-&-Radios-/-Checkbox-(Selected)" },
      _react2.default.createElement(
        "g",
        { id: "Group" },
        _react2.default.createElement("rect", {
          id: "Rectangle-5",
          fill: "#F1A637",
          x: "0",
          y: "0",
          width: "16",
          height: "16",
          rx: "2"
        }),
        _react2.default.createElement("polygon", {
          id: "Shape",
          fill: "#FFFFFF",
          fillRule: "nonzero",
          points: "12.6235558 3.2 6.13797408 9.68558169 3.23350936 7.36412226 2.13333333 8.73934229 5.65389662 11.5557929 6.2699952 12.0453625 13.8666667 4.44869099"
        })
      )
    )
  )
);

const uncheckedCheckbox = disabled => _react2.default.createElement(
  StyledSvg,
  {
    disabled: disabled,
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink"
  },
  _react2.default.createElement(
    "g",
    {
      id: "Symbols",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    },
    _react2.default.createElement(
      "g",
      {
        id: "Checks-&-Radios--/-Checkbox-(Empty)",
        fill: "#FFFFFF",
        stroke: "#CFD6E6"
      },
      _react2.default.createElement("rect", {
        id: "Rectangle-4-Copy-3",
        x: "0.5",
        y: "0.5",
        width: "15",
        height: "15",
        rx: "2"
      })
    )
  )
);
/* eslint-enable max-len */

function Checkbox({
  id,
  onChange,
  children,
  checked = false,
  disabled = false
}) {
  const checkbox = checked ? checkedCheckbox(disabled) : uncheckedCheckbox(disabled);

  const childrenProvided = _react2.default.Children.count(children);

  return _react2.default.createElement(
    StyledDiv,
    null,
    _react2.default.createElement(StyledInput, {
      type: "checkbox",
      id: id,
      name: id,
      checked: checked,
      onChange: onChange,
      disabled: disabled
    }),
    _react2.default.createElement(
      "label",
      { htmlFor: id },
      childrenProvided ? children : null,
      checkbox
    )
  );
}

Checkbox.defaultProps = {
  disabled: false
};

Checkbox.propTypes = {
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node,
  checked: _propTypes2.default.bool.isRequired,
  disabled: _propTypes2.default.bool.isRequired
};

exports.default = Checkbox;